(function() {
  'use strict';

  var HANDLES = [
    'blue-starsky-cardigan-chunky-cowichan-style-hand-knit-wool-ready-to-ship',
    'green-starsky-cardigan-chunky-cowichan-style-hand-knit-wool-ready-to-ship',
    'cream-chunky-starsky-cardigan-hand-knit-cowichan-style-wool-with-shawl-collar'
  ];

  var CACHE_KEY = 'dmk_drawer_bs_v3';
  var CACHE_TTL_MS = 1000 * 60 * 60 * 6;

  function getCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || Date.now() - obj.ts > CACHE_TTL_MS) return null;
      return obj.data;
    } catch(e) { return null; }
  }
  function setCache(data) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: data })); } catch(e) {}
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .catch(function() { return null; });
  }

  function getProducts() {
    var cached = getCache();
    if (cached) return Promise.resolve(cached);
    return Promise.all(HANDLES.map(fetchProduct))
      .then(function(results) {
        var clean = results.filter(function(p) { return p && p.handle; }).map(function(p) {
          return {
            handle: p.handle, title: p.title, url: p.url,
            image: p.featured_image || (p.images && p.images[0]) || '',
            price: p.price_min ? (p.price_min / 100) : (p.price ? p.price / 100 : 0)
          };
        });
        if (clean.length) setCache(clean);
        return clean;
      });
  }

  function formatPrice(amount) {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify.currency.active }).format(amount);
      }
    } catch(e) {}
    return '$' + amount.toFixed(2);
  }

  function buildHtml(products) {
    if (!products || !products.length) return '';
    var cards = products.map(function(p) {
      var img = p.image ? (p.image.indexOf('//') === 0 ? 'https:' + p.image : p.image) : '';
      var imgUrl = img ? img.replace(/(\.(?:jpg|jpeg|png|webp))/i, '_300x$1') : '';
      return ''
        + '<a class="dmk-drawer-bs__card" href="' + p.url + '">'
        +   '<div class="dmk-drawer-bs__media">'
        +     (imgUrl ? '<img loading="lazy" src="' + imgUrl + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" />' : '')
        +   '</div>'
        +   '<div class="dmk-drawer-bs__info">'
        +     '<div class="dmk-drawer-bs__title">' + (p.title || '') + '</div>'
        +     '<div class="dmk-drawer-bs__price">' + formatPrice(p.price) + '</div>'
        +   '</div>'
        + '</a>';
    }).join('');

    return ''
      + '<div class="dmk-drawer-bestsellers" data-dmk-injected="1">'
      +   '<div class="dmk-drawer-bestsellers__head">'
      +     '<span class="dmk-drawer-bestsellers__eyebrow">004 — THIS WEEK</span>'
      +     '<h4 class="dmk-drawer-bestsellers__title"><em>Most-Loved</em> Right Now</h4>'
      +     '<p class="dmk-drawer-bestsellers__sub">Our top 3 best-sellers, hand-knit in Daly Village.</p>'
      +   '</div>'
      +   '<div class="dmk-drawer-bs__grid">' + cards + '</div>'
      + '</div>';
  }

  function findDrawerTarget() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return null;
    var utility = drawer.querySelector('.menu-drawer__utility-links');
    var nav = drawer.querySelector('.menu-drawer__navigation');
    return { drawer: drawer, utility: utility, nav: nav };
  }

  function inject() {
    var t = findDrawerTarget();
    if (!t || !t.drawer) return false;
    if (t.drawer.querySelector('[data-dmk-injected="1"]')) return true; // already done

    getProducts().then(function(products) {
      if (!products || !products.length) return;
      var t2 = findDrawerTarget();
      if (!t2 || !t2.drawer) return;
      if (t2.drawer.querySelector('[data-dmk-injected="1"]')) return;
      var html = buildHtml(products);
      var wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      var node = wrapper.firstChild;
      if (t2.utility && t2.utility.parentNode) {
        t2.utility.parentNode.insertBefore(node, t2.utility);
      } else if (t2.nav && t2.nav.parentNode) {
        t2.nav.parentNode.appendChild(node);
      } else {
        t2.drawer.appendChild(node);
      }
    });
    return false;
  }

  function attachWatchers() {
    // Try inject immediately
    if (inject()) return;

    document.querySelectorAll('#Details-menu-drawer-container, details[id*="menu-drawer"]').forEach(function(el) {
      el.addEventListener('toggle', function() {
        if (el.open) {
          setTimeout(inject, 50);
          setTimeout(inject, 350);
          setTimeout(inject, 1000);
        }
      });
    });

    document.addEventListener('click', function(e) {
      var s = e.target.closest('summary, [aria-controls*="menu-drawer"], .header__icon--summary');
      if (s) {
        setTimeout(inject, 80);
        setTimeout(inject, 400);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachWatchers);
  } else {
    attachWatchers();
  }
})();
